import {Component, ElementRef, EventEmitter, Input, Renderer2, RendererFactory2, ViewChild} from '@angular/core';
import {QuestionnaireService} from "../../../../services/questionnaire/questionnaire.service";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {Observable} from "rxjs";
import {tap} from "rxjs/operators";
import * as Cookies from "js-cookie";
import {AlertBannerService, AlertType} from "../../../../lib/alert-banner";
import {PermissionsService} from "../../../../services/permissions/permissions.service";
import {OrganisationService} from "../../../../services/organisation/organisation.service";
import {OrgUserFilterModalComponent} from "../org-user-filter-modal/org-user-filter-modal.component";
import {ConstantsService} from "../../../../services/constants/constants.service";
import { OrgUsersService } from '../../services/org-users.service';

@Component({
  selector: 'app-manage-survey-permissions-modal',
  templateUrl: './manage-survey-permissions-modal.component.pug',
  styleUrls: ['./manage-survey-permissions-modal.component.scss'],
  standalone: false
})
export class ManageSurveyPermissionsModalComponent {
  questionnaireId = '';
  questionnaireTitle = '';
  created_by: any;
  surveys: any[] = [];
  totalSurveys = 0;

  loaded = false;
  selectAll = false;
  @Input() user: any;
  @Input() userRole: any;
  @Input() cloned = false;
  searchOptions = [{'label': $localize`Survey`, 'value': 'title', 'hint': $localize`Survey title`},
    {'label': $localize`Created by`, 'value': 'created_by', 'hint': $localize`First or last name`},];
  searchTags: any = [];
  groupDropDownOptions = [
    {
      key: $localize`Survey title`,
      value: [
        {'label': 'A-Z', 'sortString': 'title'},
        {'label': 'Z-A', 'sortString': '-title'}
      ]
    },
    {
      key: 'group-end',
      value: []
    },
    {
      key: $localize`Created by`,
      value: [
        {'label': 'A-Z', 'sortString': 'created_by'},
        {'label': 'Z-A', 'sortString': '-created_by'}
      ]
    }
  ];
  allSurveys: any[] = [];

  rowsPerView = 20;
  currentPage = 1;
  filters: any = [];
  filterCount: number = 0;
  oldFilterCount: number = 0;
  searchOutput: any = undefined;
  onSave = new EventEmitter();
  dropdownLabel = "";
  bannerType = 'amber-banner'
  bannerIcon = 'https://assets.xref.com/omni/shared/error_amber.svg';
  bannerText = $localize`By default, users with product access can see standard Xref surveys and surveys set to ‘Everyone’. Survey permissions for Owner, Administrator and Xref Support cannot be modified.`;
  orgName = '';
  isSaveButtonDisabled = true;
  filterPopupComponent: BsModalRef = new BsModalRef();

  searchQuery = {type: '', search: ''};
  @Input() userUUID = "";
  sortString: string = "";
  public renderer: Renderer2;
  sortOrder: string = "";
  initialSurveysState: any[] = [];
  @Input() surveysStates: any[] = [];
  popupBannerTitle = "";
  @Input() newUser = false;
  selectAllButtonDisabled: boolean = false;
  message: string = "";
  @Input() newUserProducts: any = [];
  @ViewChild('filterBtn', { read: ElementRef }) filterBtn!: ElementRef;


  constructor(private questionnaireService: QuestionnaireService,
              public alertList: AlertBannerService,
              private rendererFactory: RendererFactory2,
              private permission: PermissionsService,
              public organisationService: OrganisationService,
              public bsModalRef: BsModalRef,
              public modalService: BsModalService,
              public orgUserService: OrgUsersService) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  onSearchChangeCustom(searchOutput) {
    if (searchOutput.search && searchOutput.type) {
      this.loaded = false;
      this.searchQuery.search = searchOutput.search;
      this.searchQuery.type = this.searchOptions.find(option => option?.label === searchOutput?.type)?.value || searchOutput.type
      this.listSurveyPermissions()
    }

  }

  ngOnInit() {
    this.dropdownLabel = `${this.groupDropDownOptions[0].key} (${this.groupDropDownOptions[0].value[0].label})`;
    this.popupBannerTitle = (this.user?.first_name && this.user?.last_name) ? this.user?.first_name + ' ' + this.user?.last_name : (this.user?.email || $localize`New user`);
    this.listSurveyPermissions();
  }

  checkIfUserIsSurveyAdmin(surveyType: string): boolean {
    if (!this.user || !this.user.roles) {
      return false;
    }

    const surveyTypeToProductKey = {
        'reference': 'References',
        'exit': 'Exits',
        'pulse': 'Pulses'
    };

    const productKey = surveyTypeToProductKey[surveyType];

    if (!productKey) {
        return false;
    }

    const role = this.user.roles.role;
    let productRole = '';
    if (role == 'member'){
      productRole = this.user.roles.products[productKey];
    }

    return role === 'support' || role === 'owner' || (role === 'member' && productRole === 'Administrator');
}

  openFiltersModal() {
    const initialState = {
      filterTitle: "Product",
      filterOptions: [{label: $localize`Reference`, value: false, key:'reference'}, {
        label: $localize`Pulse`,
        value: false, key:'pulse'
      }, {label: $localize`Exit`, value: false, key:'exit'}]

    };

    const backdrop = this.renderer.createElement('div');
    this.renderer.addClass(backdrop, 'modal-backdrop');
    this.renderer.addClass(backdrop, 'fade');
    this.renderer.addClass(backdrop, 'show');
    this.renderer.setStyle(backdrop, 'z-index', '1050');
    this.renderer.appendChild(document.body, backdrop);

    this.filterPopupComponent = this.modalService.show(OrgUserFilterModalComponent, {
      class: 'm-popup modal-dialog modal-dialog-centered',
      initialState
    });
    this.filterPopupComponent.onHide?.subscribe(() => {
      this.renderer.removeChild(document.body, backdrop);
      this.filterBtn.nativeElement?.childNodes[0]?.blur();
    })

    this.filterPopupComponent.content?.applyFilter.subscribe(() => {
      this.renderer.removeChild(document.body, backdrop);
      this.filters = (this.filterPopupComponent.content as OrgUserFilterModalComponent).filters;
      this.filterCount = this.filters.length;
      if (Array.isArray(this.filters)) {
        this.filters = this.filters.join(",").toLowerCase();
      }
      if(this.filterCount || this.oldFilterCount != this.filterCount){
        this.listSurveyPermissions()
        this.oldFilterCount = this.filterCount;
      }
    });
  }


  listSurveyPermissions() {
    this.loaded = false;
    const userId = this.user?.user_uid
    const inviteeId = this.user?.id;
    const surveyTypes = this.getSurveyTypes();
    this.organisationService.listSurveyPermissions(userId, inviteeId, this.searchQuery.type, this.searchQuery.search, this.rowsPerView, this.currentPage, this.sortString, this.filters, surveyTypes, this.cloned).subscribe(data => {
      this.surveys = data['data'];
      this.initialSurveysState = JSON.parse(JSON.stringify(this.surveys));
      this.totalSurveys = data['total'];

      this.surveys = this.surveys.map((survey) => {
        if (survey?.questionnaire?.access == 1 || survey?.questionnaire?.is_default == true) {
            survey.is_permitted = true;
        }
        return survey;
      });
      this.translateForDisplay();

    }, error => {
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
    })

  }

  getSurveyTypes() {
    if(!this.newUserProducts.length) {
      return []
    } else if(this.newUserProducts.length == 1 && this.newUserProducts[0].filter_key == 'None') {
      return this.newUserProducts.map((value) => value.filter_key);
    } else {
      let newFilters: any = this.filters;
      if(!Array.isArray(newFilters)) {
        newFilters = newFilters.split(",")
      }
      const filteredProducts = this.newUserProducts.filter((product) => newFilters.includes(product.filter_key));
      if (filteredProducts.length) {
        return filteredProducts.map((product) => product.filter_key);
      } else {
        return this.newUserProducts.map((product) => product.filter_key);
      }
    }
  }

  clearSearch() {
    this.searchQuery.search = ""
    this.searchQuery.type = ""
    this.listSurveyPermissions()
  }

  checkIfAllEnabled() {
    if (!['owner', 'support'].includes(this.userRole?.toLowerCase()) && !!this.user) {
      this.loaded = false;
      const surveyTypes = this.getSurveyTypes()
      this.organisationService.listSurveyPermissions(this.user?.user_uid, this.user?.id, this.searchQuery.type, this.searchQuery.search, this.totalSurveys, 1, this.sortString, this.filters, surveyTypes).subscribe(data => {
        this.allSurveys = data['data'];
        this.selectAll = this.allSurveys.every(survey => survey.is_permitted);
        this.selectAllButtonDisabled = this.allSurveys.every(survey => survey.questionnaire?.access === 1 || this.checkIfUserIsSurveyAdmin(survey.survey_type));
        this.allSurveys = [];
        this.loaded = true;
      });
    }

  }
  translateForDisplay() {
    this.loaded = false;

    if ((['owner', 'support'].includes(this.userRole?.toLowerCase()) && !this.user) || (this.newUserProducts.length>0 && this.newUserProducts.every(product => product.selected === 'Administrator'))){
      const surveyTypes = this.getSurveyTypes();
      this.organisationService.listSurveyPermissions(this.user?.user_uid, this.user?.id, this.searchQuery.type, this.searchQuery.search, this.rowsPerView, this.currentPage, this.sortString, this.filters, surveyTypes, this.cloned).subscribe(data => {
        this.allSurveys = data['data'];
        this.allSurveys = this.allSurveys.map(survey => ({
          ...survey,
          is_permitted: true,
          access: 1
        }));
        this.surveys = this.allSurveys;
        this.selectAll = true;
        this.loaded = true;
        this.isSaveButtonDisabled = false;
        this.selectAllButtonDisabled = true;
      });
    }

    else if (this.newUserProducts.length>0 && this.newUserProducts.some(product => product.selected === 'Administrator')) {
      const surveyTypes = this.getSurveyTypes();
      this.organisationService.listSurveyPermissions(this.user?.user_uid, this.user?.id, this.searchQuery.type, this.searchQuery.search, this.totalSurveys, 1, this.sortString, this.filters, surveyTypes, this.cloned).subscribe(data => {
        this.allSurveys = data['data'];
        this.allSurveys.forEach(survey => {

          const product = this.newUserProducts.find(product => product.filter_key === survey.survey_type);

          if (product && product.selected === 'Administrator') {
            survey.access = 1;
             survey.is_permitted = true;
          } else {
            if(survey?.questionnaire.access == 1 || survey?.questionnaire.is_default == true) {
              survey.is_permitted = true;
              survey.access = 1;
            }
            else{
              survey.is_permitted = false;
              survey.access = 0;
            }
          }
          this.loaded = true;
        })
        this.surveys = this.allSurveys;
        this.selectAll = this.allSurveys.every(survey => survey.is_permitted);
        this.selectAllButtonDisabled = this.surveys.every(survey => survey.questionnaire?.access === 1 || survey.access == 1 || survey.questionnaire?.is_default) || this.surveys.length === 0;
        this.loaded = true;
      });

    }
    else{
      this.loaded = true;
      if (this.allSurveys.length >= this.totalSurveys) {
          this.surveys = this.surveys.map(paginatedSurvey => {
            const survey = this.allSurveys.find(survey => survey.id === paginatedSurvey.id);
            if (survey) {
              paginatedSurvey.is_permitted = survey.is_permitted;
            }
            return paginatedSurvey;
          });
          this.selectAllButtonDisabled = this.surveys.every(survey => survey.access === 1);
        }
        else {
          if (['owner', 'support'].includes(this.user?.roles?.role?.toLowerCase()) && !!this.user) {
            this.selectAll = this.surveys.every(survey => survey.is_permitted);
            this.selectAllButtonDisabled = this.surveys.every(survey => survey.questionnaire?.access === 1 || this.checkIfUserIsSurveyAdmin(survey.survey_type));
          }
          else{
            this.surveys = this.surveys.map(survey => {
              const surveyState = this.surveysStates.find(state => state.questionnaire?.id === survey.questionnaire?.id);
              if (surveyState && surveyState.is_permitted !== survey.is_permitted) {
                return {...survey, is_permitted: surveyState.is_permitted};
              }
              return survey;
            });
            if(this.user?.roles?.products && Object.values(this.user?.roles?.products).filter(value => value !== 'None').every(value => value === 'Administrator')){
              this.selectAllButtonDisabled = true;
              this.selectAll = true;
            }
            this.selectAllButtonDisabled = this.surveys.every(survey => survey.questionnaire?.access === 1 || this.checkIfUserIsSurveyAdmin(survey.survey_type) || survey.questionnaire?.is_default) || this.surveys.length === 0;
          }
        }
    }
  }

  addAllUsers() {
    if ((!['owner', 'support'].includes(this.userRole?.toLowerCase()) && !!this.user) ||
      (this.newUserProducts.length>0 && this.newUserProducts.every(product => product.selected !== 'Administrator'))) {

    this.loaded = false
    const surveyTypes = this.getSurveyTypes();
    this.organisationService.listSurveyPermissions(this.user?.user_uid, this.user?.id, this.searchQuery.type, this.searchQuery.search, this.totalSurveys, 1, this.sortString, this.filters, surveyTypes).subscribe(data => {
      this.allSurveys = data['data'];
      this.loaded = true;
      this.allSurveys.forEach(survey => {
        if (survey.access !== 1) {
          survey.is_permitted = true;
        }
      });
      this.surveys = this.allSurveys.slice(0, this.rowsPerView);
      this.selectAll = true;
      this.checkIfValueChanged();
      }, error => {
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }])
      });
    } else {
      this.allSurveys.forEach(survey => {
        const product = this.newUserProducts.find(product => product.filter_key === survey.survey_type);
        if (product?.selected !== 'Administrator') {
          survey.is_permitted = true;
          this.isSaveButtonDisabled = false;
        }
        this.selectAll = this.allSurveys.every(survey => survey.is_permitted);
      })
    }
  }

  removeAllUsers() {
    if (!['owner', 'support'].includes(this.userRole?.toLowerCase()) && !!this.user ) {
    this.loaded = false;
    this.organisationService.listSurveyPermissions(this.user?.user_uid, this.user?.id, this.searchQuery.type, this.searchQuery.search, this.totalSurveys, 1, this.sortString, this.filters).subscribe(data => {
      this.allSurveys = data['data'];
      this.loaded = true
      this.allSurveys.forEach(survey => {
          const user_product = ConstantsService.memberOptions.find(product => product.filter_key === survey.survey_type) || {name:''};
          if (this.user.roles.products[user_product?.name] !== 'Administrator' && survey?.questionnaire.access !== 1 && survey?.questionnaire.is_default != true) {
          survey.is_permitted = false;
        }
          else if (survey?.questionnaire.access == 1 || survey?.questionnaire.is_default == true) {
            survey.is_permitted = true;
          }

      });
      this.surveys = this.allSurveys.slice(0, this.rowsPerView);
      this.selectAll = false;
      this.checkIfValueChanged();
    });
    } else {
      this.allSurveys.forEach(survey => {
        const product = this.newUserProducts.find(product => product.filter_key === survey.survey_type);
        if (product?.selected !== 'Administrator') {
          survey.is_permitted = survey?.questionnaire.access == 1 || survey?.questionnaire.is_default == true;
          this.isSaveButtonDisabled = false;
        }
        this.selectAll = this.allSurveys.every(survey => survey.is_permitted);
      })
    }
  }

  onPageChange(pageNumber: any) {
    this.currentPage = pageNumber;
    if (this.allSurveys.length > this.rowsPerView) {
      const start = (this.currentPage - 1) * this.rowsPerView;
      const end = start + this.rowsPerView;
      this.surveys = this.allSurveys.slice(start, end);
    } else {
      this.listSurveyPermissions()
    }
  }

  checkIfValueChanged(survey = {}) {
    if (this.allSurveys.length >= this.rowsPerView) {
      const isCheckboxesChanged = this.surveys.some((survey, index) => survey.is_permitted !== this.initialSurveysState[index].is_permitted);
      const changedSurveys = this.surveys.filter((survey, index) => this.initialSurveysState[index] && survey.is_permitted !== this.initialSurveysState[index].is_permitted);
      this.toggleSaveButton(isCheckboxesChanged);

      changedSurveys.forEach(changedSurvey => {
        const existingSurveyIndex = this.allSurveys.findIndex(survey => survey.id === changedSurvey.id);
        if (existingSurveyIndex === -1) {
          this.allSurveys.push(changedSurvey);
        } else {
          if (this.allSurveys[existingSurveyIndex].id === changedSurvey.id && this.allSurveys[existingSurveyIndex].is_permitted !== changedSurvey.is_permitted) {
            this.allSurveys[existingSurveyIndex].is_permitted = changedSurvey.is_permitted
          }
        }
      });


    } else {

      this.surveysStates.forEach((surveyState, index) => {
        const initialSurvey = this.initialSurveysState.find(initial => initial.id === surveyState.id);
        if (initialSurvey && surveyState.is_permitted === initialSurvey.is_permitted) {
          this.surveysStates.splice(index, 1);
        }
      });
      const changedSurveys = this.surveys.filter((survey, index) => this.initialSurveysState[index] && survey.is_permitted !== this.initialSurveysState[index].is_permitted);
      changedSurveys.forEach(changedSurvey => {
        const existingSurveyIndex = this.surveysStates.findIndex(survey => survey.id === changedSurvey.id);
        if (existingSurveyIndex === -1) {
          this.surveysStates.push(changedSurvey);
        } else {
          if (survey && survey["id"] === changedSurvey.id && survey["is_permitted"] === changedSurvey.is_permitted) {
            this.surveysStates.splice(existingSurveyIndex, 1);
          }
        }
      });
      if (changedSurveys.length == 0 && !!survey) {
        const existingSurveyIndex = this.surveysStates.findIndex(surveyState => surveyState.id === survey['id']);
        this.surveysStates.splice(existingSurveyIndex, 1);
      }

      this.toggleSaveButton(true);
    }

  }

  toggleSaveButton(enable: boolean): void {
    this.isSaveButtonDisabled = !enable;
  }

  changePermissionsUpdated(event, survey) {
    survey.is_permitted = event;
    this.checkIfValueChanged(survey)
  }


  cancel() {
    this.bsModalRef?.hide();
  }


  onSortChange(event) {
    this.sortString = event['sortString'];
    this.dropdownLabel = ` ${event.key} (${event.label})`;
    this.listSurveyPermissions()
  }

  onPageSizeChange(rowsPerView) {
    this.rowsPerView = rowsPerView;
    this.currentPage = 1;
    if (this.allSurveys.length > this.rowsPerView) {
      const start = (this.currentPage - 1) * this.rowsPerView;
      const end = start + this.rowsPerView;
      this.surveys = this.allSurveys.slice(start, end);
    } else {
      this.listSurveyPermissions()
    }
  }

  savePermissions() {
    this.loaded = false;
    if (this.allSurveys.length > this.rowsPerView) {
      this.surveys = this.allSurveys;
    } else if (this.surveysStates.length > 0) {
      this.surveys = this.surveysStates
    }
    this.message = "savePermissionConfirm";
    if (this.newUser) {
      this.loaded = true
      this.bsModalRef.hide()
      return
    }
    const changedSurvey =this.surveys.reduce((acc, survey) => {
      if(!(survey?.access == 1 || this.checkIfUserIsSurveyAdmin(survey.survey_type) || (survey.questionnaire?.access == 1 || survey.questionnaire?.is_default))){
        acc.push({
          ...survey,
          questionnaires: survey.surveys
        });
      }
      return acc;
    }, []);
    this.organisationService.saveSurveyPermissions(this.user?.user_uid, this.user?.id, changedSurvey).subscribe(data => {
      this.loaded = true;
      this.bsModalRef.hide();
      this.alertList.append([{
        type: AlertType.SUCCESS,
        message: $localize`Success! Changes have been saved.`,
        keepOnRouteChange: true
      }])
    }, error => {
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }])
    });
  }
}
